import auth from "./auth";
import models from "./models";
import { combineReducers } from 'redux'

export default combineReducers({
    auth, models
})
// export { mApp }
